import {HStack, VStack} from "_ui/Box";
import React, {memo, Suspense} from "react";
import QrCodeSuspense from "_components/suspense/QrCodeSuspense";
import {QrCode} from "./QrCode";
import {InputCode} from "_ui/InputCode";
import {useEnableTwoFactor} from "_api/hooks/two-factor";
import {toastRun} from "_utils/misc";
import {toastSuccess} from "_components/ToastProvider";
import styled from "styled-components";
import {AuthService} from "_services/auth.service";

const QrCodeWrapper = styled.div`
    width: 100%;
    max-width: 300px;
`

export const RegisterTwoFactor = memo(() => {
    const {mutateAsync: enableTwoFactor, isPending: loading} = useEnableTwoFactor();

    const onCodeEntered = async (code: string) => {
        AuthService.registering2FAStart();

        await toastRun(
            enableTwoFactor({code}),
            () => toastSuccess('Autenticação em dois fatores ativada.'),
            () => AuthService.registering2FAEnd()
        );
    }

    return (
        <VStack g={2}>
            <h3>Autenticação em Dois Fatores</h3>
            <HStack g={4} wrap>
                <VStack>
                    <h4>QR Code</h4>
                    <p>Escaneie o QR Code com o seu aplicativo de autenticação.</p>
                    <QrCodeWrapper>
                        <Suspense fallback={<QrCodeSuspense/>}>
                            <QrCode/>
                        </Suspense>
                    </QrCodeWrapper>
                </VStack>

                <VStack shrink>
                    <h4>Habilitar 2FA</h4>
                    <p>Insira o código de 6 dígitos gerado no seu aplicativo para ativar a autenticação em dois
                        fatores.</p>
                    <InputCode {...{onCodeEntered, loading}}/>
                </VStack>
            </HStack>

        </VStack>
    );
});
